import { render, staticRenderFns } from "./DeviceRequestSerialNumber.vue?vue&type=template&id=7b059988&scoped=true&"
import script from "./DeviceRequestSerialNumber.vue?vue&type=script&lang=js&"
export * from "./DeviceRequestSerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRequestSerialNumber.vue?vue&type=style&index=0&id=7b059988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b059988",
  null
  
)

export default component.exports